import { useInjectReducer, useInjectSaga } from 'redux-injectors';
import { useEffect } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import makePaquerypointSelector from './selectors';
import { name, reducer, actions } from './slice';
import saga from './saga';

export default function usePaquerypoints({ initialize } = {}) {
  const dispatch = useDispatch();
  useInjectReducer({ key: name, reducer });
  useInjectSaga({ key: name, saga });
  useSelector(makePaquerypointSelector(), shallowEqual);
  useEffect(() => {
    if (initialize) {
      dispatch(actions.initial());
    }
    return () => {
      dispatch(actions.resetFilters());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
  return null;
}
